import { useRef, useState } from 'react';
import './About.css';
import weddingPhoto from '../../assets/wedding.jpg';

export default function Content() {
  const photoRef = useRef(null);
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = photoRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width  - 0.5) * 10;
    const y = ((e.clientY - rect.top)  / rect.height - 0.5) * -10;
    setTilt({ x, y });
  };

  const handleMouseLeave = () => setTilt({ x: 0, y: 0 });

  return (
    <section id="about" className="content-section">

      {/* ── Text Side ── */}
      <div className="content-text">

        <div className="content-eyebrow">Our Story</div>

        <h2 className="content-heading">
          We Capture<br />
          <span className="bold">Every Precious</span><br />
          <span className="italic-red">Moment.</span>
        </h2>

        <p className="content-para">
          Brand Partner Studio is a premium photography and videography studio
          based in Tamil Nadu. We specialise in wedding photography, baby shoots,
          and family portraits — crafting timeless memories with a cinematic touch.
        </p>

        <p className="content-para">
          With over 13 years of experience and 1000+ Events captured, every frame
          we shoot tells a story that lasts forever.
        </p>

        {/* Stats */}
        <div className="content-stats">
          <div className="stat-item">
            <span className="stat-num">1000+</span>
            <span className="stat-lbl">Signature Events</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">13+</span>
            <span className="stat-lbl">Years Experience</span>
          </div>
          <div className="stat-item">
            <span className="stat-num">100%</span>
            <span className="stat-lbl">Happy Clients</span>
          </div>
        </div>

      </div>

      {/* ── Photo Side — Tilt Wrapper ── */}
      <div
        className="content-photo"
        ref={photoRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          transform: `perspective(1000px) rotateY(${tilt.x}deg) rotateX(${tilt.y}deg)`,
          transition: tilt.x === 0 && tilt.y === 0
            ? 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
            : 'transform 0.1s ease',
          willChange: 'transform',
        }}
      >
        <div className="content-photo-border" />
        <img
          src={weddingPhoto}
          alt="Wedding Photography by Brand Partner Studio"
          style={{
            /* image subtle counter-tilt for depth feel */
            transform: `translateX(${tilt.x * -1.5}px) translateY(${tilt.y * -1.5}px)`,
            transition: tilt.x === 0 && tilt.y === 0
              ? 'transform 0.6s ease'
              : 'transform 0.12s ease',
          }}
        />
        <div className="content-photo-tag">Wedding Photography</div>
      </div>

    </section>
  );
}